export default "__VITE_ASSET__C0p5ixWR__"